export const useCaseOptions = [
  { value: "contractor", label: "受注したい" },
  { value: "client", label: "発注したい" },
  { value: "both", label: "両方利用したい" },
];
